<template>
  <div class="order-info" id="orderlist" v-loading="loading">
    <div class="order_info_tips">
      <img src="@/assets/img/order_info_tips.svg" alt="" />
      <span
        >温馨提示：若“未到货”，需在到货后修改状态，师傅才会与客户进行预约</span
      >
    </div>
    <!-- <el-alert type="warning" class="alert_info" v-if="!$store.state.abnormal">
      <svg class="icon iconz_toast_warn" aria-hidden="true">
        <use xlink:href="#iconz_toast_warn" /></svg
      >有异常订单需您处理，处理后师傅才能进行下一步
    </el-alert> -->

    <div :class="{ 'order-xinxi': !$store.state.abnormal }">
      <!-- <div class="title-mode">订单信息</div> -->
      <div class="order-tit">
        <div>服务信息</div>
        <div>客户信息</div>
        <div>上门时间</div>
        <div class="orders-status">订单状态</div>
        <div class="orders-operate">订单操作</div>
      </div>
      <div class="order-tit orders-list">
        <div>
          <div>{{ orderInfo.goodsTypeName }}</div>
          {{ orderInfo.serviceTypeName }}
        </div>
        <div>
          <div>{{ orderInfo.customerName }}</div>
          {{ orderInfo.customerPhone }}
        </div>
        <div>
          {{ orderInfo.appointmentTime || "/" }}
        </div>
        <div class="orders-status">
          {{ orderInfo.statusName }}
          <div
            style="color: #909399"
            v-if="orderInfo.childOrder && orderInfo.childOrder.status"
          >
            {{ setStatus(orderInfo.childOrder.status) }}
          </div>
        </div>
        <div class="orders-operate">
          <!-- <template v-if="orderInfo.status != 'CLOSE'"> -->
          <template>
            <div class="remaining_time" v-if="orderInfo.status == 'WAIT_PAY'">
              {{ orderInfo.expirationTimeStr }}
            </div>
            <div
              class="remaining_time"
              v-if="
                orderInfo.status == 'WAIT_ACCEPT' &&
                  orderInfo.isAcceptance == false
              "
            >
              等待重新完工拍照
            </div>
            <div
              class="remaining_time"
              v-if="
                orderInfo.status == 'WAIT_ACCEPT' &&
                  orderInfo.isAcceptance == null
              "
            >
              {{ orderInfo.acceptTimeStr }}
            </div>
            <div class="state_text" v-if="orderInfo.status == 'WAIT_VERIF'">
              *等待师傅完成核销
            </div>

            <div
              style="margin-bottom: 8px"
              class="com_check"
              v-if="orderInfo.status == 'WAIT_PAY'"
              @click="orderPayment(orderInfo)"
            >
              立即付款
            </div>

            <!-- <div
              class="com_check"
              style="
                color: #c0c4cc;
                cursor: not-allowed;
                background-image: none;
                background-color: #fff;
                border: 1px solid #ebeef5;
              "
              v-if="orderInfo.status == 'WAIT_ASSIGN'"
            >
              确认到货
            </div> -->
            <div
              class="com_check"
              v-if="
                (orderInfo.status == 'WAIT_ASSIGN' ||
                  orderInfo.status == 'WAIT_APPOINTMENT' ||
                  orderInfo.status == 'RECEIVING_ORDER') &&
                  !orderInfo.isArrival
              "
              @click="arrival()"
            >
              确认到货
            </div>

            <div
              class="com_check com_dib_check"
              v-if="orderInfo.status == 'WAIT_VERIF'"
            >
              立即验收
            </div>
            <div
              class="com_check com_dib_check"
              v-if="
                orderInfo.status == 'WAIT_ACCEPT' &&
                  orderInfo.isAcceptance == false
              "
            >
              立即验收
            </div>
            <div
              class="com_check"
              v-if="
                orderInfo.status == 'WAIT_ACCEPT' &&
                  orderInfo.isAcceptance == null
              "
              @click="openAcceptance(orderInfo)"
            >
              立即验收
            </div>
            <div
              class="com_check com_pin_check"
              v-if="orderInfo.status == 'SUCCESS'"
              @click="evaluate = true"
            >
              评价
            </div>
            <div
              class="com_state_box_info"
              v-if="orderInfo.status == 'EVALUATED'"
            >
              已评价
            </div>
            <template v-if="orderInfo.orderType != 'TIMELY'">
              <div
                class="com_check"
                v-if="
                  orderInfo.isGoodsAbnormal &&
                    orderInfo.status != 'WAIT_VERIF' &&
                    orderInfo.status != 'WAIT_ACCEPT' &&
                    !orderInfo.solveExceptionWay
                "
                @click="processAbnormal(orderInfo)"
              >
                处理异常
              </div>
            </template>

            <div class="order-bottom">
              <div
                class="com_state_box_info"
                v-if="orderInfo.status == 'WAIT_PAY'"
                @click="orderCancel(orderInfo)"
              >
                取消订单
              </div>
              <div
                class="com_state_box_info"
                v-if="orderInfo.status != 'WAIT_PAY'"
                @click="editRemark(orderInfo)"
              >
                添加跟进
              </div>

              <!-- <div
                class="com_state_box_info"
                v-if="
                  orderInfo.status != 'WAIT_PAY' &&
                  orderInfo.status != 'CLOSE' &&
                  orderInfo.status != 'SUCCESS' &&
                  orderInfo.status != 'EVALUATED'
                "
                @click="openOrderInfo(orderInfo)"
              >
                订单详情
              </div> -->

              <el-divider direction="vertical"></el-divider>
              <el-dropdown trigger="click" @command="handleCommand">
                <span class="el-dropdown-link">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="orderInfo.status == 'WAIT_PAY'"
                    :command="{ data: orderInfo, type: '添加跟进' }"
                    >添加跟进</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="
                      orderInfo.status == 'WAIT_ACCEPT' &&
                        orderInfo.isAcceptance == null
                    "
                    :command="{ data: orderInfo, type: '延长验收' }"
                    >延长验收</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="
                      orderInfo.status != 'WAIT_PAY' &&
                        orderInfo.status != 'CLOSE'
                    "
                    :command="{ data: orderInfo, type: '添加异常' }"
                    >添加异常</el-dropdown-item
                  >
                  <!-- <el-dropdown-item>添加异常</el-dropdown-item> -->
                  <!-- <template v-if="orderInfo.orderType != 'TIMELY'"> -->
                  <template>
                    <el-dropdown-item
                      v-if="
                        orderInfo.status != 'WAIT_PAY' &&
                          orderInfo.status != 'CLOSE' &&
                          orderInfo.status != 'SUCCESS' &&
                          orderInfo.status != 'EVALUATED'
                      "
                      :command="{
                        data: orderInfo,
                        type: '订单加价',
                      }"
                      >订单加价</el-dropdown-item
                    >
                  </template>
                  <el-dropdown-item
                    v-if="
                      orderInfo.status != 'WAIT_PAY' &&
                        orderInfo.status != 'CLOSE' &&
                        orderInfo.status != 'SUCCESS' &&
                        orderInfo.status != 'EVALUATED'
                    "
                    :command="{ data: orderInfo, type: '申请退款' }"
                    >申请退款</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="orderInfo.orderType == 'TIMELY'"
                    :command="{ data: orderInfo, type: '复制订单' }"
                    >复制订单</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
          <div
            class="com_state_box_info"
            v-if="orderInfo.status == 'CLOSE' && orderInfo.refundId"
          >
            /
          </div>
          <!-- <el-button class="video_call" @click="editRemark(orderInfo)"
            >添加跟进</el-button
          > -->
        </div>
      </div>

      <div class="total_price">
        订单总金额：
        <div>￥{{ orderInfo.totalAmount }}</div>
      </div>

      <!--<template>
          <div class="pay-order" v-if="!orderInfo.refundDetailResponse">
            <el-button
              class="zhifu"
              v-if="orderInfo.status == 'WAIT_PAY'"
              @click="orderPay()"
              >立即付款</el-button
            >
            <el-button
              class="zhifu prohibit"
              v-if="orderInfo.status == 'WAIT_VERIF'"
              >验收</el-button
            >
            <el-button
              class="zhifu prohibit"
              v-if="
                orderInfo.status == 'WAIT_ACCEPT' &&
                orderInfo.isAcceptance == false
              "
              >验收</el-button
            >
            <el-button
              class="zhifu"
              v-if="
                orderInfo.status == 'WAIT_ACCEPT' &&
                orderInfo.isAcceptance == null
              "
              @click="openAcceptance()"
              >验收</el-button
            >
            <el-button
              class="zhifu"
              v-if="orderInfo.status == 'SUCCESS'"
              @click="evaluate = true"
              >评价</el-button
            >
            <el-button
              class="zhifu"
              v-if="
                (orderInfo.status == 'WAIT_APPOINTMENT' ||
                  orderInfo.status == 'RECEIVING_ORDER') &&
                !orderInfo.isArrival
              "
              @click="arrival()"
              >确认到货</el-button
            >
            <span
              class="cancel-order"
              v-if="orderInfo.status == 'WAIT_PAY'"
              @click="orderCancel()"
              >取消订单</span
            >
            <span
              class="cancel-order"
              v-if="
                orderInfo.status != 'WAIT_PAY' &&
                orderInfo.status != 'CLOSE' &&
                orderInfo.status != 'SUCCESS' &&
                orderInfo.status != 'EVALUATED'
              "
              @click="markupCheck(orderInfo)"
              >加价</span
            >
            <span
              class="cancel-order"
              v-if="
                orderInfo.status != 'WAIT_PAY' &&
                orderInfo.status != 'SUCCESS' &&
                orderInfo.status != 'CLOSE' &&
                orderInfo.status != 'EVALUATED'
              "
              @click="openRefund(orderInfo)"
              >退款</span
            >
            <span
              class="cancel-order"
              v-if="
                orderInfo.status == 'WAIT_PICK_UP' ||
                orderInfo.status == 'WAIT_INSTALL' ||
                orderInfo.status == 'WAIT_COMPLETE' ||
                orderInfo.status == 'WAIT_VERIF' ||
                orderInfo.status == 'WAIT_ACCEPT'
              "
              @click="complaintCheck(orderInfo)"
              >投诉</span
            >
            <span
              class="cancel-order"
              :class="orderInfo.acceptanceDelayDays > 0 ? 'extend' : ''"
              v-if="orderInfo.status == 'WAIT_ACCEPT'"
              @click="extendOrder(orderInfo)"
              >延长验收</span
            >
          </div>

          <div class="juguan" v-if="orderInfo.status == 'WAIT_PAY'">
            距订单关闭{{ orderInfo.expirationTimeStr }}
          </div>
          <div
            class="juguan"
            v-if="
              orderInfo.status == 'WAIT_VERIF' && orderInfo.isAcceptance == null
            "
          >
            *等待师傅完成核销
          </div>
          <div
            class="juguan default-text"
            v-if="orderInfo.status == 'WAIT_ACCEPT'"
          >
            {{ "还剩" + orderInfo.acceptTimeStr }}
          </div>
          <div
            class="juguan default-text"
            v-if="
              orderInfo.status == 'WAIT_ACCEPT' &&
              orderInfo.isAcceptance == false
            "
          >
            等待重新完工拍照
          </div>
        </template>-->
    </div>

    <div class="order-tab">
      <div
        class="item-tab"
        v-for="(item, index) in orderTab"
        :class="{ select: item.isSelected }"
        @click="selectTba(item, index)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="ordermin">
      <div class="basic-info" v-if="orderTab[0].isSelected">
        <div class="service-type base-info" style="margin-top: 0px">
          <div class="title-mode">服务信息</div>
          <div class="xinxi">
            <div class="tabclass duan">
              <span class="label">商品类目：</span>
              <i>{{ orderInfo.goodsTypeName }}</i>
            </div>
            <div class="tabclass zhong">
              <span class="label">服务类型：</span>
              <i>{{ orderInfo.serviceTypeName }}</i>
            </div>
            <div class="tabclass zhong">
              <span class="label">订单类型：</span>
              <i>{{
                orderInfo.orderType == "TIMELY" ? "即时订单" : "服务商订单"
              }}</i>
            </div>
            <div class="tabclass zhong">
              <span class="label">订单编号：</span>
              <i>{{ orderInfo.orderNo }}</i>
            </div>
            <div
              class="tabclass time-period"
              v-if="orderInfo.orderType == 'TIMELY'"
            >
              <span class="label">服务时段：</span>
              <div>
                <i v-for="item in orderInfo.orderServicePeriodList">{{
                  item.date + " " + item.startTime + "-" + item.endTime
                }}</i>
              </div>
            </div>
          </div>
        </div>

        <div class="service-type base-info">
          <div class="title-mode">客户信息</div>
          <div class="xinxi">
            <div class="tabclass duan">
              <span class="label">客户姓名：</span>
              <i>{{ orderInfo.customerName }}</i>
            </div>
            <div class="tabclass zhong">
              <span class="label">联系电话：</span>
              <i>{{ orderInfo.customerPhone }}</i>
            </div>

            <div class="tabclass elevator duan">
              <span class="label">是否有电梯：</span>
              <i style="width: auto">{{ orderInfo.isLift ? "有" : "无" }}</i>
              <!-- <i style="width: auto" v-if="orderInfo.floorsNumber">
                {{ "（楼层" + orderInfo.floorsNumber + "）" }}
              </i> -->
            </div>
            <div class="tabclass duan">
              <span class="label">住几楼：</span>
              <i>{{
                orderInfo.floorsNumber ? orderInfo.floorsNumber + "楼" : "/"
              }}</i>
            </div>
            <div class="tabclass chang">
              <span class="label">联系地址：</span>
              <i>{{ orderInfo.address }}</i>
            </div>
          </div>
        </div>

        <div class="service-type base-info">
          <div class="title-mode">物流信息</div>
          <div class="xinxi">
            <div class="tabclass duan">
              <span class="label">货物位置：</span>
              <i
                >{{ orderInfo.isArrival ? "已到货" : "未到货"
                }}<span v-if="orderInfo.orderType == 'TIMELY'"
                  >（{{
                    orderInfo.orderExpand.isJishiTihuoFei
                      ? "已到提货点"
                      : "已到客户家"
                  }}）</span
                ></i
              >
            </div>
            <div class="tabclass duan">
              <span class="label">物流公司：</span>
              <i>{{ orderInfo.logisticsName || "/" }}</i>
            </div>
            <div class="tabclass duan">
              <span class="label">物流单号：</span>
              <i>{{ orderInfo.logisticsNo || "/" }}</i>
            </div>
            <div class="tabclass duan">
              <span class="label">物流电话：</span>
              <i>{{
                !orderInfo.logisticsPhone ? "/" : orderInfo.logisticsPhone
              }}</i>
            </div>
            <div class="tabclass duan">
              <span class="label">提货码：</span>
              <i>{{ orderInfo.pickupCode || "/" }}</i>
            </div>
            <div class="tabclass duan" v-if="orderInfo.orderType != 'TIMELY'">
              <span class="label">到货时间：</span>
              <i>{{ orderInfo.arrivalTime || "/" }}</i>
            </div>
            <div class="tabclass duan">
              <span class="label">距离客户：</span>
              <i
                v-if="
                  orderInfo.orderExpand && orderInfo.orderExpand.pickupDistance
                "
                >{{
                  orderInfo.orderExpand.pickupDistance
                    ? (
                        Number(orderInfo.orderExpand.pickupDistance) / 1000
                      ).toFixed(2) + "km"
                    : "/"
                }}</i
              >
            </div>
            <div class="tabclass duan" style="width: 640px">
              <span class="label">提货地址：</span>
              <i style="width: 565px">
                <!-- {{
                  orderInfo.pickupAreaName
                    ? orderInfo.pickupAreaName + " "
                    : ""
                }} -->
                {{ orderInfo.pickupAddress || "/" }}</i
              >
            </div>
          </div>
        </div>

        <div class="service-type base-info">
          <div class="title-mode">订单商品</div>
          <div class="xinxi">
            <div class="tabclass duan">
              <span class="label">提货车型：</span>
              <i
                v-if="
                  orderInfo.orderExpand &&
                    orderInfo.orderExpand.pickupCarTypeName
                "
                >{{ orderInfo.orderExpand.pickupCarTypeName || "/" }}</i
              >
            </div>
            <div class="tabclass duan">
              <span class="label">包装件数：</span>
              <i>{{ orderInfo.packingCount || "/" }}</i>
            </div>
            <div class="tabclass duan">
              <span class="label">订单体积：</span>
              <i>{{ orderInfo.totalVolume || "/" }}</i>
            </div>
          </div>
        </div>

        <div class="goods-info">
          <div class="goods">
            <div class="goods-tab">
              <div class="shang">商品信息</div>
              <div class="shang_mingc">商品名称</div>
              <div class="shang_leib">商品类别</div>
              <div class="shuliang">商品数量</div>
              <div class="baozhuang">包装方式</div>
            </div>

            <div class="goods-list">
              <div
                class="item-goods"
                v-for="(item, index) in orderInfo.orderItems"
              >
                <div class="shang">
                  <el-image
                    :src="item.imgUrl"
                    :preview-src-list="[item.imgUrl]"
                  >
                  </el-image>
                  <el-button
                    @click="openVideo(item)"
                    class="install_video"
                    v-if="item.installVideoUrl"
                    style="width: auto"
                    ><i class="iconfont iconbiaodan_vedio"></i>
                    安装视频</el-button
                  >
                </div>
                <div class="shang_mingc mingcheng">
                  <span class="ellipsis">{{ item.name }}</span>
                </div>
                <div class="shang_leib leibie">
                  <span class="ellipsis">{{ item.goodsTypeName }}</span>
                </div>
                <div class="shuliang">{{ item.count }}</div>
                <div class="baozhuang">{{ item.packingMethod || "/" }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="service-type base-info">
          <div class="title-mode">其他信息</div>
          <div class="xinxi">
            <div class="tabclass duan">
              <span class="label">核销：</span>
              <i>{{
                orderInfo.verifType == "NOT"
                  ? "不需要"
                  : orderInfo.verifType == "MIAO"
                  ? "喵师傅"
                  : "汪师傅"
              }}</i>
            </div>
            <div class="tabclass zhong">
              <span class="label">核销单号：</span>
              <i>{{
                orderInfo.verifOrderNo == "" || orderInfo.verifOrderNo == null
                  ? "/"
                  : orderInfo.verifOrderNo
              }}</i>
            </div>

            <div class="tabclass duan" style="width: auto">
              <span class="label" style="width: auto">期望服务日期：</span>
              <i v-if="orderInfo.orderType == 'TIMELY'">{{
                orderInfo.expectedTime || "/"
              }}</i>
              <i v-else>{{
                orderInfo.expectedTime
                  ? orderInfo.expectedTime.split(" ")[0]
                  : "/"
              }}</i>
            </div>
            <div class="tabclass chang">
              <span class="label">订单备注：</span>
              <i>{{ orderInfo.remark || "/" }}</i>
            </div>
          </div>
        </div>
        <div class="service-type base-info">
          <div class="title-mode">订单问题联系人</div>
          <div class="xinxi">
            <div class="tabclass duan">
              <span class="label">姓名：</span>
              <i>{{ orderInfo.userName }}</i>
            </div>
            <div class="tabclass duan">
              <span class="label">联系电话：</span>
              <i>{{ orderInfo.userPhone }}</i>
            </div>
          </div>
        </div>

        <div class="service-type base-info" v-if="orderInfo.payTime">
          <div class="title-mode">下单支付信息</div>
          <div class="xinxi">
            <div class="tabclass duan">
              <span class="label">支付时间：</span>
              <i>{{
                orderInfo.status == "WAIT_PAY"
                  ? "/"
                  : new Date(orderInfo.payTime).format("yyyy-MM-dd HH:mm:ss")
              }}</i>
            </div>
            <div class="tabclass duan">
              <span class="label">支付金额：</span>
              <i>{{
                orderInfo.status == "WAIT_PAY"
                  ? "/"
                  : "¥" + orderInfo.originalAmount
              }}</i>
            </div>
            <div class="tabclass duan">
              <span class="label">支付方式：</span>
              <i>{{
                orderInfo.payWay == "WALLET"
                  ? "余额支付"
                  : orderInfo.payWay == "ALIPAY"
                  ? "支付宝支付"
                  : orderInfo.payWay == "WECHAT"
                  ? "微信支付"
                  : "/"
              }}</i>
            </div>
            <div class="tabclass duan">
              <span class="label">支付状态：</span>
              <i>{{
                orderInfo.status == "WAIT_PAY" || orderInfo.status == "CLOSE"
                  ? orderInfo.statusName
                  : "支付成功"
              }}</i>
            </div>
            <div class="tabclass duan">
              <span class="label">流水号：</span>
              <i>{{ orderInfo.outOrderNo || "/" }}</i>
            </div>
          </div>
        </div>

        <div
          class="service-type base-info"
          v-if="orderInfo.orderMarkups.length != 0"
          v-for="(item, index) in orderInfo.orderMarkups"
        >
          <div class="title-mode">加价记录{{ index + 1 }}</div>
          <div class="xinxi">
            <div class="tabclass duan">
              <span class="label">加价类型：</span>
              <i>{{ setMarkupType(item.markupType) || "/" }}</i>
            </div>
            <div class="tabclass duan">
              <span class="label">支付金额：</span>
              <i>¥{{ item.amount }}</i>
            </div>
            <div class="tabclass duan">
              <span class="label">支付方式：</span>
              <i>{{
                item.payWay == "WALLET"
                  ? "余额支付"
                  : item.payWay == "ALIPAY"
                  ? "支付宝支付"
                  : item.payWay == "WECHAT"
                  ? "微信支付"
                  : "/"
              }}</i>
            </div>
            <div class="tabclass duan">
              <span class="label">支付时间：</span>
              <i>{{ new Date(item.payTime).format("yyyy-MM-dd HH:mm:ss") }}</i>
            </div>
            <div class="tabclass chang">
              <span class="label">订单备注：</span>
              <i>{{ item.markupRemark || "/" }}</i>
            </div>
          </div>
        </div>

        <div class="base-info">
          <div class="step_one_price">
            <div
              class="one_tab"
              v-for="(item, index) in orderInfo.orderServiceFees"
            >
              <div class="one_price_name">{{ item.name }}：</div>
              <div class="one_price">¥{{ item.fee }}</div>
            </div>
            <div class="one_tab">
              <div class="one_price_name">师傅服务费：</div>
              <div class="one_price">¥{{ orderInfo.workerFee }}</div>
            </div>
            <div class="one_tab" v-if="orderInfo.markupAmount">
              <div class="one_price_name">加价总费用：</div>
              <div class="one_price">¥{{ orderInfo.markupAmount }}</div>
            </div>
            <div class="one_tab">
              <div class="one_price_name">应付总额：</div>
              <div class="one_price one_total" style="width: auto">
                ¥{{ orderInfo.totalAmount }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="service-info" v-if="orderTab[1].isSelected">
        <div
          v-if="
            orderInfo.status != 'WAIT_PAY' &&
              orderInfo.status != 'WAIT_ASSIGN' &&
              orderInfo.status != 'RECEIVING_ORDER'
          "
        >
          <div class="service-type base-info">
            <div class="title-mode">师傅信息</div>
            <div class="xinxi">
              <div class="tabclass zhong">
                <span class="label">师傅姓名：</span>
                <i v-if="orderInfo.orderType == 'TIMELY'">聚师傅</i>
                <i v-else>{{ orderInfo.workerName || "/" }}</i>
              </div>
              <div
                class="tabclass zhong"
                v-if="orderInfo.orderType == 'GENERAL'"
              >
                <span class="label">联系电话：</span>
                <i>{{ orderInfo.workerPhone || "/" }}</i>
              </div>
              <div class="tabclass zhong">
                <span class="label">接单时间：</span>
                <i>{{ orderInfo.assignWorkerTime || "/" }}</i>
              </div>
            </div>
          </div>

          <div
            class="service-type base-info"
            v-if="orderInfo.orderExpand.appointResult"
          >
            <div class="title-mode">预约信息</div>
            <div class="xinxi">
              <div class="tabclass zhong">
                <span class="label">预约结果：</span>
                <i>{{
                  orderInfo.orderExpand.appointResult == "SUCCESS"
                    ? "预约成功"
                    : "预约失败"
                }}</i>
              </div>
              <div class="tabclass zhong">
                <span class="label">操作时间：</span>
                <i>{{ orderInfo.appointmentCreateTime || "/" }}</i>
              </div>
              <div class="tabclass zhong" v-if="orderInfo.appointmentTime">
                <span class="label">预约上门：</span>
                <i>{{ orderInfo.appointmentTime || "/" }}</i>
              </div>
              <div class="tabclass zhong">
                <span class="label">失败原因：</span>
                <i>{{ orderInfo.orderExpand.appointFailReason || "/" }}</i>
              </div>
              <!-- <div class="tabclass zhong">
                <span class="label">预约时间：</span>
                <i>{{ orderInfo.appointmentTime || "/" }}</i>
              </div>
              <div class="tabclass zhong">
                <span class="label">预约提交时间：</span>
                <i style="width: auto">{{
                  orderInfo.appointmentCreateTime || "/"
                }}</i>
              </div> -->
            </div>
          </div>

          <!-- <div class="logistics-info" v-if="orderInfo.isGoodsAbnormal"> -->
          <div class="logistics-info" v-if="orderInfo.orderGoodsPickUp">
            <div class="title-mode">提货信息</div>
            <div class="xinxi">
              <span v-if="orderInfo.orderGoodsPickUp">
                <!-- <div class="tabclass" v-if="orderInfo.orderGoodsPickUp&&orderInfo.orderGoodsPickUp.outPackType==3">
                  <span class="label">有无异常：</span>
                  <span>无 外包装完好 包装件数正常</span>
                </div> -->
                <!-- <div class="tabclass" v-else> -->
                <div class="tabclass">
                  <!-- <span class="label">有无异常：</span> -->
                  <span style="color: #f75658"
                    >提货异常
                    <i
                      style="margin: 0 3px 0 8px"
                      class="el-icon-warning-outline"
                    ></i
                    >{{ setOutPackType(takeDelivery.outPackType) }}
                    <i
                      style="margin: 0 3px 0 8px"
                      class="el-icon-warning-outline"
                    ></i
                    >包装件数{{
                      takeDelivery.packNum == orderInfo.packingCount
                        ? takeDelivery.packNum + "件"
                        : takeDelivery.packNum + "件不"
                    }}正常</span
                  >
                  <!-- <a style="margin-left: 8px">立即处理</a> -->
                </div>
                <div class="tabclass">
                  <span class="label">提货备注：</span>
                  <div>{{ orderInfo.orderGoodsPickUp.content || "/" }}</div>
                </div>
                <div
                  class="tabclass img-info"
                  v-if="orderInfo.orderGoodsPickUp.imgs"
                >
                  <span class="label">提货拍照：</span>
                  <div>
                    <template
                      v-for="(item, index) in orderInfo.orderGoodsPickUp.imgs"
                    >
                      <el-image
                        v-if="imgOrVideo(item.url).type == 'img'"
                        :src="imgOrVideo(item.url).url"
                        :preview-src-list="
                          setPreviewList(orderGoodsPickUpimgLis)
                        "
                      ></el-image>
                      <el-image
                        style="cursor: pointer"
                        v-if="imgOrVideo(item.url).type == 'video'"
                        :src="imgOrVideo(item.url).url"
                        @click="openVideo({ installVideoUrl: item.url })"
                      ></el-image>
                      <audio
                        v-if="imgOrVideo(item.url).type == 'audio'"
                        controls
                        :src="imgOrVideo(item.url).url"
                      ></audio>
                      <a
                        v-if="imgOrVideo(item.url).type == 'download'"
                        :href="imgOrVideo(item.url).url"
                        target="_blank"
                        >媒体下载</a
                      >
                    </template>
                  </div>
                </div>
                <div class="tabclass">
                  <span class="label">操作时间：</span>
                  {{
                    !orderInfo.orderGoodsPickUp.createTime
                      ? "/"
                      : new Date(orderInfo.orderGoodsPickUp.createTime).format(
                          "yyyy-MM-dd HH:mm:ss"
                        )
                  }}
                </div>
              </span>
            </div>
          </div>

          <!-- <div v-if="!!orderInfo.signArea" class="logistics-info"> -->
          <div v-if="!!orderInfo.signArea" class="service-type base-info">
            <div class="title-mode">上门签到</div>
            <div class="xinxi">
              <div class="tabclass zhong">
                <span class="label">签到时间：</span>
                <!-- <i>{{ new Date(orderInfo.signInTime).format("yyyy-MM-dd") }}</i> -->
                <i>{{
                  new Date(orderInfo.signInTime).format("yyyy-MM-dd HH:mm:ss")
                }}</i>
              </div>
              <div class="tabclass zhong">
                <span class="label">签到状态：</span>
                <i
                  >{{ orderInfo.isSignAreaNormal ? "区域正常、" : "区域异常、"
                  }}{{
                    orderInfo.isSignTimeNormal ? "时间正常" : "时间异常"
                  }}</i
                >
              </div>
              <div class="tabclass chang">
                <span class="label">签到地点：</span>
                <i
                  ><a>{{ orderInfo.signArea || "/" }}</a></i
                >
              </div>
            </div>
          </div>

          <div class="logistics-info" v-if="orderInfo.orderCompleteConfirm">
            <div class="title-mode">完工信息</div>
            <div class="xinxi">
              <div class="tabclass">
                <span class="label">完工内容：</span>
                {{ orderInfo.orderCompleteConfirm.content }}
              </div>
              <div
                class="tabclass img-info"
                v-if="orderInfo.orderCompleteConfirm.imgs"
              >
                <span class="label">完工照片：</span>
                <template v-for="(item, index) in orderInfo.orderCompleteConfirm.imgs">
                <el-image
                  v-if="imgOrVideo(item.url).type == 'img'"
                  :src="imgOrVideo(item.url).url"
                  :preview-src-list="setPreviewList(orderCompleteConfirmimgLis)"
                ></el-image>
                <el-image
                  v-if="imgOrVideo(item.url).type == 'video'"
                  style="cursor: pointer"
                  :src="imgOrVideo(item.url).url"
                  @click="openVideo({ installVideoUrl: item.url })"
                ></el-image>
                <audio
                    v-if="imgOrVideo(item.url).type == 'audio'"
                    controls
                    :src="imgOrVideo(item.url).url"
                  ></audio>
                  <a
                    v-if="imgOrVideo(item.url).type == 'download'"
                    :href="imgOrVideo(item.url).url"
                    target="_blank"
                    >媒体下载</a
                  >
              </template>
              </div>
              <div class="tabclass">
                <span class="label">完工时间：</span>
                {{
                  new Date(orderInfo.orderCompleteConfirm.createTime).format(
                    "yyyy-MM-dd HH:mm:ss"
                  )
                }}
              </div>
            </div>
          </div>

          <!-- <div class="base-infos"> -->
          <div class="logistics-info" v-if="!!orderInfo.solveExceptionWay">
            <div class="title-mode">异常处理</div>
            <div class="xinxi">
              <div class="tabclass">
                <span class="label">处理时间：</span>
                {{ orderInfo.solveExceptionTime || "/" }}
              </div>
              <div class="tabclass">
                <span class="label">处理方式：</span>
                {{ solveExceptionWay(orderInfo.solveExceptionWay) }}
              </div>
            </div>
          </div>

          <div class="logistics-info" v-if="orderInfo.isAcceptance">
            <div class="title-mode">核销信息</div>
            <div class="xinxi">
              <div class="tabclass">
                <span class="label">核销状态：</span>
                {{ !orderInfo.verifyTime ? "未核销" : "已核销" }}
              </div>
              <div class="tabclass">
                <span class="label">核销时间：</span>
                {{
                  orderInfo.verifyTime
                    ? new Date(orderInfo.verifyTime).format(
                        "yyyy-MM-dd HH:mm:ss"
                      )
                    : "/"
                }}
              </div>
              <div
                class="tabclass img-info"
                v-if="writeOffData.length && writeOffData[0].imgUrl"
              >
                <span class="label">核销凭证：</span>
                <template v-for="(item, index) in writeOffData[0].imgUrl.split(',')">
                <el-image
                  v-if="imgOrVideo(item).type == 'img'"
                  :src="imgOrVideo(item).url"
                  :preview-src-list="
                    setPreviewList(writeOffData[0].imgUrl.split(','))
                  "
                ></el-image>
                <el-image
                  style="cursor: pointer"
                  v-if="imgOrVideo(item).type == 'video'"
                  :src="imgOrVideo(item).url"
                  @click="openVideo({ installVideoUrl: item })"
                ></el-image>
                <audio
                    v-if="imgOrVideo(item).type == 'audio'"
                    controls
                    :src="imgOrVideo(item).url"
                  ></audio>
                  <a
                    v-if="imgOrVideo(item).type == 'download'"
                    :href="imgOrVideo(item).url"
                    target="_blank"
                    >媒体下载</a
                  >
              </template>
              </div>
            </div>
          </div>

          <div
            class="service-type base-info"
            v-if="orderInfo.isAcceptance != null"
          >
            <div class="title-mode">验收信息</div>
            <div class="xinxi">
              <div class="tabclass zhong">
                <span class="label">验收时间：</span>
                <i v-if="orderInfo.acceptanceTime">{{
                  new Date(orderInfo.acceptanceTime).format(
                    "yyyy-MM-dd HH:mm:ss"
                  )
                }}</i>
                <i v-else>/</i>
              </div>
              <div class="tabclass zhong">
                <span class="label">验收方式：</span>
                <i>
                  {{
                    orderInfo.acceptanceWay == "SYS" ? "系统验收" : "人工验收"
                  }}
                </i>
              </div>
              <div class="tabclass zhong">
                <span class="label">验收结果：</span>
                <i>{{ orderInfo.isAcceptance ? "验收通过" : "验收不通过" }}</i>
              </div>
            </div>
          </div>

          <!-- 补充凭证 -->
          <div class="logistics-info" v-if="addInfo.length">
            <div class="title-mode">补充凭证</div>
            <div class="xinxi" v-for="item in addInfo">
              <div class="tabclass">
                <span class="label">详细内容：</span>
                {{ item.content }}
              </div>
              <div
                class="tabclass img-info"
                style="flex-wrap: wrap;"
                v-if="item.imgUrl"
              >
                <span class="label">补充凭证：</span>
                <template v-for="(it, index) in item.imgUrl.split(',')">
                  <el-image
                    v-if="imgOrVideo(it).type == 'img'"
                    :src="imgOrVideo(it).url"
                    :preview-src-list="setPreviewList(item.imgUrl.split(','))"
                  ></el-image>
                  <el-image
                    style="cursor: pointer"
                    v-if="imgOrVideo(it).type == 'video'"
                    :src="imgOrVideo(it).url"
                    @click="openVideo({ installVideoUrl: it })"
                  ></el-image>
                  <audio
                    v-if="imgOrVideo(it).type == 'audio'"
                    controls
                    :src="imgOrVideo(it).url"
                  ></audio>
                  <a
                    v-if="imgOrVideo(it).type == 'download'"
                    :href="imgOrVideo(it).url"
                    target="_blank"
                    >媒体下载</a
                  >
                </template>
              </div>
              <div class="tabclass">
                <span class="label">提交时间：</span>
                {{ new Date(item.createTime).format("yyyy-MM-dd HH:mm:ss") }}
              </div>
            </div>
          </div>

          <div
            class="logistics-info evaluate"
            v-if="orderInfo.orderEvaluation != null"
          >
            <div class="title-mode">订单评价</div>
            <div class="xinxi">
              <div class="pingfen">
                <el-rate
                  class="rate-view"
                  v-model="orderInfo.orderEvaluation.star"
                  void-icon-class="iconfont iconguanwang_icon_pingjia"
                  :icon-classes="iconClasses"
                  :colors="['#FFAD16', '#FFAD16', '#FFAD16']"
                  show-text
                ></el-rate>
                <div class="p-date">
                  {{
                    new Date(orderInfo.orderEvaluation.createTime).format(
                      "yyyy-MM-dd HH:mm:ss"
                    )
                  }}
                </div>
              </div>
              <div class="ping-text">
                {{ orderInfo.orderEvaluation.content }}
              </div>
              <div class="tab-pin" v-if="orderInfo.orderEvaluation.label">
                <div
                  class="tab-pin"
                  v-for="(item, index) in orderInfo.orderEvaluation.label.split(
                    '[@]jushifu[@]'
                  )"
                  :key="index"
                >
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <!-- </div> -->
        </div>
        <div v-else>
          <div class="null-info">
            <img src="../../assets/img/pic_none.png" alt />
            暂无服务信息...
          </div>
        </div>
      </div>

      <div class="service-info" v-if="orderTab[2].isSelected">
        <div v-if="refund">
          <div class="base-infos">
            <div
              class="logistics-info"
              v-if="
                refundData.status == 'SUCCESS' ||
                  refundData.status == 'PROCESSED'
              "
            >
              <div class="title-mode">退款信息</div>
              <div class="xinxi">
                <div class="tabclass">
                  <span class="label">退款单号：</span>
                  {{ refundData.refundNo }}
                </div>
                <div class="tabclass red">
                  <span class="label">实际退款金额：</span>
                  ￥{{ refundData.refundAmount }}
                </div>
                <div class="tabclass" v-if="!!refundData.refundSuccessTime">
                  <span class="label">退款时间：</span>
                  {{
                    new Date(refundData.refundSuccessTime).format(
                      "yyyy-MM-dd HH:mm:ss"
                    )
                  }}
                </div>
                <div class="tabclass">
                  <span class="label">退款方式：</span>
                  {{ refundData.payWay || "/" }}
                </div>
                <div class="tabclass">
                  <span class="label">退款结果：</span>
                  {{ refundResult }}
                </div>
              </div>
            </div>

            <!-- <div
          class="logistics-info"
          v-if="orderInfo.refundReason=='接单中订单退款'&&!!orderInfo.refundDetailResponse"
          >-->
            <div class="logistics-info" v-if="!!refundData.refundReason">
              <div class="title-mode">申请信息</div>
              <div class="xinxi">
                <div class="tabclass">
                  <span class="label">退款金额：</span>
                  <span v-if="refundData.applyRefundAmount == null">/</span>
                  <span v-else>¥{{ refundData.applyRefundAmount || 0 }}</span>
                </div>
                <div
                  class="tabclass"
                  v-if="refundData && refundData.refundReason == '平台取消'"
                >
                  <span class="label">补贴师傅金额：</span>
                  ¥{{ refundData.allowance + refundData.childAllowance }}
                </div>
                <div
                  class="tabclass"
                  v-if="refundData && refundData.refundReason != '平台取消'"
                >
                  <span class="label">补贴师傅金额：</span>
                  ¥{{ refundData.allowance }}
                </div>

                <div class="tabclass">
                  <span class="label">退款原因：</span>
                  {{ refundData.refundReason }}
                </div>
                <div class="tabclass">
                  <span class="label">详细描述：</span>
                  {{ refundData.description || "/" }}
                </div>
                <div
                  class="tabclass img-info"
                  v-if="imgLis.length == 0 ? false : true"
                >
                  <span class="label">相关凭证：</span>
                  <!-- <img
                v-for="(item, index) in refundData.imgs"
                :key="index"
                :src="item.url"
                alt
                />-->
                  <el-image
                    v-for="(item, index) in refundData.imgs"
                    :key="index"
                    :src="item.url"
                    :preview-src-list="imgLis"
                  ></el-image>
                </div>
              </div>
            </div>

            <div class="logistics-info" v-if="refundData.status != 'CANCEL'">
              <div class="title-mode">审核信息</div>
              <div class="xinxi">
                <div class="tabclass">
                  <span class="label">审核结果：</span>
                  {{
                    refundData.status == "WAIT"
                      ? "待审核"
                      : refundData.status == "AGREE" ||
                        refundData.status == "SUCCESS"
                      ? "同意"
                      : "拒绝"
                  }}
                </div>
                <div class="tabclass">
                  <span class="label">审核内容：</span>
                  {{
                    !refundData.refuseRefundContent
                      ? "/"
                      : refundData.refuseRefundContent
                  }}
                </div>
                <div class="tabclass">
                  <span class="label">审核人：</span>
                  {{ refundData.contactName || "/" }}
                </div>
                <div class="tabclass">
                  <span class="label">联系电话：</span>
                  {{ refundData.contactPhone || "/" }}
                </div>
                <div class="tabclass" v-if="refundData.status != 'WAIT'">
                  <span class="label">审核时间：</span>
                  {{
                    new Date(refundData.updateTime).format(
                      "yyyy-MM-dd HH:mm:ss"
                    )
                  }}
                </div>
              </div>
            </div>

            <div class="logistics-info" v-if="!!refundData.arbitrationNo">
              <div class="title-mode">仲裁信息</div>
              <div class="xinxi">
                <div class="tabclass lan">
                  <span class="label">仲裁单号：</span>
                  <a @click="goArbitration">{{ refundData.arbitrationNo }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="null-info">
            <img src="../../assets/img/pic_none.png" alt />
            暂无退款信息...
          </div>
        </div>
      </div>
      <!-- 跟进记录 -->
      <div class="service-info" v-show="orderTab[3].isSelected">
        <follow-up ref="followUp"></follow-up>
      </div>
      <!-- 异常记录 -->
      <div class="service-info" v-show="orderTab[4].isSelected">
        <abnormal-list ref="abnormalList"></abnormal-list>
      </div>
      <!-- 加价申请 -->
      <div class="service-info" v-show="orderTab[5].isSelected">
        <markup-list ref="markupList" :orderId="orderInfo.id"></markup-list>
      </div>

      <!-- 物流地图 -->
      <div class="service-info" v-show="orderTab[6].isSelected">
        <logistics-map ref="logisticsMap"></logistics-map>
      </div>
    </div>

    <!-- 确认是否到货 -->
    <el-dialog
      title="确认商品到货"
      :visible.sync="inArrival"
      class="arrival"
      :append-to-body="true"
      id="orderlist"
    >
      <div>
        <div class="arrival-tishi">为了确保师傅顺利取货，请补充物流信息</div>
        <div class="two_label">
          <div class="type_name"><span class="xing">*</span>物流单号</div>
          <div class="type_content">
            <el-input
              v-model="logisticsData.logisticsNo"
              placeholder="请输入"
            ></el-input>
          </div>
        </div>
        <div class="two_label">
          <div class="type_name"><span class="xing">*</span>物流电话</div>
          <div class="type_content">
            <el-input
              v-model="logisticsData.logisticsPhone"
              placeholder="请输入"
              maxlength="12"
            ></el-input>
          </div>
        </div>
        <div class="two_label">
          <div class="type_name">物流公司</div>
          <div class="type_content">
            <!-- <el-input
              v-model="logisticsData.logisticsCompany"
              placeholder="请输入"
            ></el-input> -->
            <el-select
              v-model="logisticsData.logisticsCompany"
              filterable
              remote
              reserve-keyword
              placeholder="请输入物流公司名称"
              :remote-method="getLogisticsCompany"
              :loading="logloading"
              @change="getLogisticsCompany"
            >
              <el-option
                v-for="item in logisticsCompany"
                :key="item.value"
                :label="item.companyName"
                :value="item.companyCode"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="two_label">
          <div class="type_name">提货码</div>
          <div class="type_content">
            <el-input
              v-model="logisticsData.pickupCode"
              placeholder="请输入"
            ></el-input>
          </div>
        </div>
        <div class="two_label">
          <div class="type_name">提货地址</div>
          <div class="type_content">
            <el-input
              v-model="logisticsData.pickupAddress"
              placeholder="请输入"
              @input="getPickUpLnglat"
            ></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="inArrival = false">取 消</el-button>
        <el-button type="primary" @click="isarrival()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title
      :visible.sync="notArrival"
      :append-to-body="true"
      id="orderlist"
    >
      <div class="notarrival">
        <svg class="icon iconz_toast_warn" aria-hidden="true">
          <use xlink:href="#iconz_toast_warn" />
        </svg>
        确认修改商品状态为已到货吗？
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="notArrival = false">取 消</el-button>
        <el-button type="primary" @click="isarrival()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 加价 -->
    <increase-price
      :orderData="orderInfo"
      :markup="markup"
      v-on:showMarkup="showMarkup"
      v-on:increasePrice="increasePrice"
      id="orderlist"
    ></increase-price>

    <!-- 评价 -->
    <el-dialog
      title="评价师傅"
      :visible.sync="evaluate"
      width="30%"
      class="complaint evaluate"
      :append-to-body="true"
      id="orderlist"
    >
      <div>
        <div class="evaluate-tab">
          <div class="tab_name">下单时间：</div>
          {{ orderInfo.createTime || "/" }}
        </div>
        <div class="evaluate-tab">
          <div class="tab_name">服务类型：</div>
          {{ orderInfo.serviceTypeName }}
        </div>
        <div class="evaluate-tab evaluate-img">
          <div class="tab_name">安装师傅：</div>
          <img
            class="avatar-evaluate"
            :src="
              !orderInfo.workerAvatar == true
                ? workerAvatar
                : orderInfo.workerAvatar
            "
            alt
          />
          {{ orderInfo.workerName }}
        </div>
        <div class="evaluate-tab imgs-eva">
          <div class="tab_name">商品图片：</div>
          <img
            class="item-imgs"
            v-for="(item, index) in orderInfo.orderItems"
            :src="item.imgUrl"
            alt
          />
        </div>
        <div class="evaluate-tab imgs-score rate-size">
          <div class="tab_name">
            <span style="color: #f75658">*</span>师傅评分：
          </div>
          <el-rate
            v-model="workRateValue"
            void-icon-class="iconfont iconguanwang_icon_pingjia"
            :icon-classes="iconClasses"
            :colors="['#FFAD16', '#FFAD16', '#FFAD16']"
            :texts="texts"
            show-text
          ></el-rate>
        </div>
        <div class="evaluate-tab eva-impression">
          <div class="tab_name">印象标签：</div>
          <div class="impression">
            <div
              class="tabs"
              v-for="(item, index) in impressionList"
              @click="impressionCheck(item)"
              :class="{ selected: item.isSelected }"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="evaluate-tab eva-content">
          <div class="tab_name">评价内容：</div>
          <el-input
            v-model="impressionContent"
            placeholder="请输入投诉内容"
            type="textarea"
            class="textarea-text"
            maxlength="500"
            show-word-limit
          ></el-input>
        </div>
        <div class="complaint-img eva-upload-imgs">
          <div class="complaint-title">相关图片</div>
          <a-upload
            :action="baseApl + '/common/common/upload_file'"
            listType="picture-card"
            :fileList="evaluateList"
            @change="evaluateChange"
            :data="webToken"
            :headers="webToken"
          >
            <div v-if="evaluateList.length < 8">
              <a-icon type="plus" />
              <div class="ant-upload-text">上传</div>
            </div>
          </a-upload>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="evaluate = false">取 消</el-button>
        <el-button type="primary" @click="evaluateCheck()">确 定</el-button>
      </span>
    </el-dialog>
    <followup-modal ref="followupModal" @ok="getFollowup"></followup-modal>
    <com-complaint
      :orderNo="complaintOrderNo"
      :complaint="complaint"
      v-on:showComplaint="showComplaint"
    ></com-complaint>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
    <video-play ref="videoPlay"></video-play>
    <videoCall-modal ref="videoCallModal"></videoCall-modal>
    <abnormalFollow-modal ref="abnormalFollowModal"></abnormalFollow-modal>
  </div>
</template>

<script>
import increasePrice from "./increase_price";
import comComplaint from "./com_complaint";
import followUp from "./modules/followUp";
import videoPlay from "./modules/videoPlay";
import followupModal from "./modules/followupModal";
import logisticsMap from "./modules/logisticsMap";
import abnormalList from "./modules/abnormalList";
import markupList from "./modules/markupList";
import { imgOrVideo } from "@/utils/util";
import { ORDER_STATUS } from "@/utils/constant";
import videoCallModal from "./modules/videoCallModal";
import abnormalFollowModal from "./modules/abnormalFollowModal";
import { copyMixins } from "@/mixins/copyMixins";

export default {
  mixins: [copyMixins],
  components: {
    increasePrice,
    comComplaint,
    followUp,
    logisticsMap,
    videoPlay,
    followupModal,
    abnormalList,
    markupList,
    videoCallModal,
    abnormalFollowModal,
  },
  data() {
    return {
      orderid: "",
      refundId: "",
      rateValue: 3,
      inArrival: false,
      notArrival: false,
      markup: false,
      complaint: false,
      icon: false,
      evaluate: false,
      complaintOrderNo: "",
      webToken: {
        WEB_TOKEN: Cookies.get("token"),
      },
      workRateValue: 0,
      texts: ["非常差", "差", "一般", "好", "非常好"],
      iconClasses: [
        "iconfont iconguanwang_icon_pingjia",
        "iconfont iconguanwang_icon_pingjia",
        "iconfont iconguanwang_icon_pingjia",
      ],
      impressionContent: "",
      workerAvatar: require("../../assets/img/pic_head_nor.png"),
      fileList: [],
      evaluateList: [],
      impressionList: [],
      logisticsData: {
        logisticsNo: "",
        logisticsPhone: "",
        logisticsCompany: "",
        pickupCode: "",
        pickupAddress: "",
      },
      orderTab: [
        { name: "基本信息", isSelected: true },
        { name: "服务信息", isSelected: false },
        { name: "退款信息", isSelected: false },
        { name: "跟进记录", isSelected: false },
        { name: "异常记录", isSelected: false },
        { name: "加价申请", isSelected: false },
        { name: "物流地图", isSelected: false },
      ],
      orderMarkups: [],
      orderInfo: {
        orderMarkups: [],
        orderNo: "",
        orderEvaluation: { label: "服务态度好！[@]jushifu[@]服务态度差！" },
        orderExpand: {},
      },
      logisticsCompany: [],
      refund: false,
      refundData: {},
      imgLis: [],
      orderGoodsPickUpimgLis: [],
      orderCompleteConfirmimgLis: [],
      showEdit: false,
      remark: "",
      remarkInfo: {},
      loading: false,
      logloading: false,
      baseApl: process.env.VUE_APP_BASE_API,
      followUpList: [],
      previewImage: "",
      previewVisible: false,
      takeDelivery: {},
      writeOffData: [],
      addInfo: [],
    };
  },
  watch: {
    // orderid() {
    //   console.log(this.orderid);
    //   let _this = this;
    //   if (Cookies.get("token") != undefined) {
    //     this.getOrderInfo();
    //     this.getFollowup()
    //     // 评价师傅tag
    //     this.$fetch(`/common/api/tag`).then((res) => {
    //       if (res.code == 0) {
    //         for (let i of res.data) {
    //           i.isSelected = false;
    //           i.name = i.content;
    //         }
    //         _this.impressionList = res.data;
    //       } else {
    //         this.$message(res.message);
    //       }
    //     });
    //   }
    // },
  },
  // activated() {
  // let _this = this;
  // if (Cookies.get("token") != undefined) {
  //   this.getOrderInfo();
  //   this.getFollowup();
  // // 评价师傅tag
  // this.$fetch(`/common/api/tag`).then((res) => {
  //   if (res.code == 0) {
  //     for (let i of res.data) {
  //       i.isSelected = false;
  //       i.name = i.content;
  //     }
  //     _this.impressionList = res.data;
  //   } else {
  //     this.$message(res.message);
  //   }
  // });
  // }
  // },
  computed: {
    refundResult() {
      let result = "";
      if (this.refundData.status == "WAIT") {
        result = "待处理";
      }
      if (this.refundData.status == "AGREE") {
        result = "同意退款";
      }
      if (this.refundData.status == "REFUSE") {
        result = "拒绝退款";
      }
      if (this.refundData.status == "ARBITRATION") {
        result = "仲裁";
      }
      if (this.refundData.status == "PROCESSED") {
        result = "仲裁已处理";
      }
      if (this.refundData.status == "SUCCESS") {
        result = "退款成功";
      }
      if (this.refundData.status == "FAIL") {
        result = "退款失败";
      }
      if (this.refundData.status == "CANCEL") {
        result = "取消退款";
      }
      if (this.refundData.status == "ARBITRATION_CANCEL") {
        result = "取消仲裁";
      }
      return result;
    },
  },
  methods: {
    imgOrVideo,
    // 跳转总裁详情
    goArbitration() {
      this.$router.push({
        path: "/user/right/detail",
        query: {
          refundId: this.refundData.id,
        },
      });
    },
    setStatus(status) {
      for (let i in ORDER_STATUS) {
        if (i == status) return "（送货-" + ORDER_STATUS[i].name + "）";
      }
    },
    // 添加异常
    addAbnormalFollow(item) {
      this.$refs.abnormalFollowModal.add(item);
    },
    init() {
      console.log(this.orderid);
      let _this = this;
      if (Cookies.get("token") != undefined) {
        // 初始化tab
        this.orderTab.map((i) => {
          i.isSelected = false;
        });
        this.orderTab[0].isSelected = true;
        this.getOrderInfo();
        this.getFollowup();
        // 评价师傅tag
        this.$fetch(`/common/api/tag`).then((res) => {
          if (res.code == 0) {
            for (let i of res.data) {
              i.isSelected = false;
              i.name = i.content;
            }
            _this.impressionList = res.data;
          } else {
            this.$message(res.message);
          }
        });
        this.getLogisticsCompany();
        this.getAddPriceType();
      }
    },
    // 获取加价类型
    getAddPriceType() {
      this.$fetch("/common/api/dictItem/find_sys_dict_item", {
        dictCode: "add_price_type",
      }).then(({ data, code }) => {
        console.log(data);
        if (code == 0) this.orderMarkups = data;
      });
    },
    setMarkupType(type) {
      for (let i of this.orderMarkups) {
        if (i.itemValue == type) return i.itemText;
      }
    },
    // 获取物流公司
    getLogisticsCompany(e) {
      console.log(e);
      let params = {
        name: e,
        pageNo: 1,
        pageSize: 20,
      };
      this.$fetch("/common/api/wuliu/wuliu_company_search", params).then(
        (res) => {
          if (res.code == 0) {
            this.logisticsCompany = res.data.records;
          }
        }
      );
    },
    // 获取凭证信息
    getOrderOredence() {
      // 补充凭证
      this.$fetch(`/order/api/order_credence/query_credence`, {
        orderId: this.orderInfo.id,
        type: "BUCHONG_CREDENCE",
      }).then((res) => {
        console.log(res);
        if (res.code == 0) this.addInfo = res.data;
      });
      // 核销凭证
      this.$fetch(`/order/api/order_credence/query_credence`, {
        orderId: this.orderInfo.id,
        type: "HEXIAO_CREDENCE",
      }).then((res) => {
        console.log(res);
        if (res.code == 0) this.writeOffData = res.data;
      });
    },
    // 获取提货拍照信息
    getTakeDelivery() {
      this.$fetch(`/order/api/order/query_take_delivery`, {
        orderId: this.orderInfo.childOrder
          ? this.orderInfo.childOrder.id
          : this.orderInfo.id,
      }).then((res) => {
        console.log(res);
        if (res.code == 0) this.takeDelivery = res.data || {};
      });
    },
    setOutPackType(type) {
      if (type == 1) return "外包装褶皱/变形";
      else if (type == 2) return "外包装破损";
      else if (type == 3) return "外包装完好";
      else return "/";
    },
    handleCommand(item = {}) {
      this.$message.closeAll();
      console.log(item);
      if (item.type == "添加跟进") return this.editRemark(item.data);
      else if (item.type == "订单加价") return this.markupCheck();
      else if (item.type == "申请退款") return this.openRefund(item.data);
      else if (item.type == "延长验收") return this.extendOrder(item.data);
      else if (item.type == "添加异常")
        return this.addAbnormalFollow(item.data);
      else if (item.type == "复制订单") return this.copyOrder(item.data);
      // return this.$message({
      //   message: "功能即将上线",
      //   type: "warning",
      // });
    },
    setPreviewList(list) {
      return list.map((i) => this.imgOrVideo(i).url);
    },
    // 播放视频
    openVideo(item) {
      this.$refs.videoPlay.init(item);
    },
    handleCancel() {
      this.previewVisible = false;
    },
    // 获取异常记录
    getAbnormalList() {
      this.$refs.abnormalList.getList();
    },
    // 获取跟进记录
    getFollowup() {
      this.$refs.followUp.getFollowup();
    },
    // 获取物流跟进记录
    getLogisticsInfo() {
      this.$refs.logisticsMap.loadData();
    },
    // 打开备注编辑
    editRemark(item) {
      this.$refs.followupModal.add(item);
    },

    // 申请退款
    openRefund(item,flag) {
      this.$emit("close");
      if (!flag) {
        if (item.status == "RECEIVING_ORDER" && item.childOrder&&item.childOrder.workerId) {
          return this.$router.push({
            path: "/user/order/refund/modify",
            query: { orderid: item.id },
          });
        }
        if (
          item.status == "RECEIVING_ORDER" ||
          item.status == "WAIT_PAY" ||
          item.status == "WAIT_ASSIGN"
        ) {
          this.$confirm("您确定要退款吗", "", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$fetch(
                `/order/api/order/${item.id}/wait_assign_order_refund`
              ).then((res) => {
                if (res.code == 0) {
                  // item.status = "CLOSE";
                  // item.statusName = "订单关闭";
                  this.$emit('ok')
                  this.$message({
                    type: "success",
                    message: "退款成功!",
                  });
                } else {
                  this.$message(res.message);
                }
              });
            })
            .catch(() => {});
        } else {
          this.$router.push({
            path: "/user/order/refund/modify",
            query: { orderid: item.id },
          });
        }
      } else {
        this.$router.push({
          path: "/user/order/refund/modify",
          query: { orderid: item.orderId, type: flag },
        });
      }
      // this.$router.push({
      //   path: "/user/order/refund/modify",
      //   query: { orderid: item.id },
      // });
    },
    // 打开投诉
    complaintCheck(item, index) {
      this.complaintOrderNo = item.orderNo;
      this.complaint = true;
    },
    // 跳转异常处理
    processAbnormal(item) {
      this.$router.push({
        path: "/user/order/abnormal",
        query: { orderid: item.id },
      });
    },
    // 延长验收
    extendOrder(item) {
      console.log(item);
      this.$confirm("确定延长验收吗？每笔订单只能延长一次", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$fetch(
            `/order/api/order/acceptance_order_delay?orderId=${item.id}`
          ).then((res) => {
            if (res.code == 0) {
              item.acceptanceDelayDays = 1;
              item.acceptTimeStr = res.data.acceptTimeStr;
              this.$message({
                type: "success",
                message: "延长成功!",
              });
            } else {
              this.$message(res.message);
            }
          });
        })
        .catch(() => {});
    },
    showComplaint(val) {
      this.complaint = val;
    },
    // 评价师傅
    evaluateCheck() {
      var _this = this;
      var label = [];
      var imgs = [];
      for (let i of _this.impressionList) {
        if (i.isSelected) {
          label.push(i.name);
        }
      }
      for (let i of _this.evaluateList) {
        imgs.push(i.response.data.url);
      }
      this.$post(`/order/api/order/${this.orderInfo.id}/evaluation`, {
        star: _this.workRateValue,
        content: _this.impressionContent,
        isAnonymous: false,
        label: label,
        imgs: imgs,
      }).then((res) => {
        if (res.code == 0) {
          _this.evaluate = false;
          this.getOrderInfo();
          this.$message({
            message: "评论成功",
            type: "success",
          });
        } else {
          this.$message(res.message);
        }
      });
    },
    // 加价
    showMarkup(val) {
      console.log(val);
      this.getOrderInfo();
      this.markup = val;
    },
    // 加了多少钱
    increasePrice(val) {
      var _this = this;
      var item = _this.orderInfo;
      item.totalAmount = Number(val) + Number(item.totalAmount);
    },
    selectTba(item, index) {
      this.orderTab.map((i) => {
        i.isSelected = false;
      });
      this.orderTab[index].isSelected = true;
      if (item.name == "物流地图") this.$refs.logisticsMap.setMap();
      // item.isSelected = true;
    },
    // 清空图片缓存
    clearImgs() {
      this.imgLis = [];
      this.orderGoodsPickUpimgLis = [];
      this.orderCompleteConfirmimgLis = [];
    },
    // 获取订单详情
    getOrderInfo() {
      this.refundData = {};
      this.orderInfo = { id: "" };
      this.refund = false;
      var _this = this;
      this.loading = true;
      let orderid = _this.$route.query.orderid || this.orderid;
      this.clearImgs();
      this.$fetch(`/order/api/order/${orderid}`)
        .then((res) => {
          if (res.code == 0) {
            console.log(res.data.orderType);
            _this.orderInfo = res.data;
            _this.$refs.followUp.orderInfo = _this.orderInfo;
            _this.$refs.logisticsMap.orderInfo = _this.orderInfo;
            _this.getTakeDelivery();
            _this.getOrderOredence();
            _this.getFollowup();
            this.getAbnormalList();
            _this.getLogisticsInfo();

            if (res.data.refundDetailResponse) {
              _this.refundData = res.data.refundDetailResponse;
              this.refund = true;
              res.data.refundDetailResponse.imgs.map((i) => {
                _this.imgLis.push(i.url);
              });
            }
            if (res.data.orderGoodsPickUp) {
              res.data.orderGoodsPickUp.imgs.map((i) => {
                _this.orderGoodsPickUpimgLis.push(i.url);
              });
            }
            if (res.data.orderCompleteConfirm) {
              res.data.orderCompleteConfirm.imgs.map((i) => {
                _this.orderCompleteConfirmimgLis.push(i.url);
              });
            }
          } else {
            this.$message(res.message);
          }
        })
        .finally(() => (this.loading = false));
    },
    impressionCheck(item) {
      item.isSelected = !item.isSelected;
    },
    // 立即支付
    orderPayment() {
      this.$emit("close");
      this.$router.push({
        path: "/placeorder/Orderpayment",
        query: { orderid: this.orderInfo.id },
      });
    },
    // 取消订单
    orderCancel() {
      var _this = this;
      this.$confirm("您确定要取消此订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$post(`/order/api/order/${_this.orderInfo.id}/cancel`).then(
            (res) => {
              if (res.code == 0) {
                _this.getOrderInfo();
                this.$message({
                  type: "success",
                  message: "取消成功!",
                });
              } else {
                this.$message(res.message);
              }
            }
          );
        })
        .catch(() => {});
    },
    // 查询提货位置
    getPickUpLnglat() {
      let _this = this;
      let params = {
        key: process.env.VUE_APP_MAP_KEY,
        address: this.logisticsData.pickupAddress,
      };

      $.ajax({
        type: "get",
        dataType: "jsonp",
        cache: false,
        data: params,
        url: "https://restapi.amap.com/v3/geocode/geo",

        success: function(json) {
          console.log(json);
          if (json.info == "OK") {
            _this.logisticsData.pickUpLng = json.geocodes[0].location.split(
              ","
            )[0];
            _this.logisticsData.pickUpLat = json.geocodes[0].location.split(
              ","
            )[1];
          }
        },
      });
    },
    // 确认到货
    arrival() {
      if (this.orderInfo.isNeedTakeDelivery) {
        this.inArrival = true;
        this.logisticsData = {
          logisticsNo: item.logisticsNo,
          logisticsPhone: item.logisticsPhone,
          logisticsCompany: item.logisticsCompany,
          pickupAddress: item.pickupAddress,
          pickupCode: item.pickupCode,
        };
      } else {
        this.notArrival = true;
      }
    },
    isarrival() {
      var _this = this;
      var item = _this.orderInfo;
      var data = _this.logisticsData;
      if (this.orderInfo.isNeedTakeDelivery) {
        if (data.logisticsNo == "") {
          this.$message({
            showClose: true,
            message: "请输入物流单号",
            type: "error",
          });
          return;
        }
        if (parseFloat(data.logisticsPhone).toString() == "NaN") {
          this.$message({
            showClose: true,
            message: "请输入合法的手机号",
            type: "error",
          });
          return;
        }
      }

      this.$post(`/order/api/order/${item.id}/arrival`, {
        logisticsNo: data.logisticsNo,
        logisticsPhone: data.logisticsPhone,
        logisticsCompany: data.logisticsCompany,
        pickupCode: data.pickupCode,
        pickupAddress: data.pickupAddress,
        pickUpLat: data.pickUpLat,
        pickUpLng: data.pickUpLng,
      }).then((res) => {
        if (res.code == 0) {
          _this.notArrival = false;
          _this.inArrival = false;
          item.isArrival = true;
        } else {
          this.$message(res.message);
        }
      });
    },
    // 加价
    markupCheck() {
      // this.markup = true;
      if (this.orderInfo.orderType != "TIMELY") {
        if (
          this.orderInfo.status == "SUCCESS" ||
          this.orderInfo.status == "EVALUATED"
        ) {
          this.$confirm(
            "当前订单已交易完成，已无法申请退款。订单加价支付后将会直接到师傅账上。",
            "加价提醒",
            { confirmButtonText: "我知道了", cancelButtonText: "不加价了" }
          )
            .then(() => {
              // this.$refs.markupPay.init(rows);
              this.markup = true;
            })
            .catch(() => {});
        } else {
          // this.$refs.markupPay.init(rows);
          this.markup = true;
        }
      } else {
        sessionStorage.setItem("orderId", this.orderInfo.id);
        this.$refs.videoCallModal.init(this.orderInfo, "markup");
      }
    },

    passType(item) {
      var _this = this;
      if (item == "password") {
        _this.passwordType = "text";
      }
      if (item == "text") {
        _this.passwordType = "password";
      }
    },
    // 跳转验收
    openAcceptance() {
      this.$emit("close");
      this.$router.push({
        path: "/user/order/acceptance",
        query: { orderid: this.orderInfo.id },
      });
    },
    // 评论拍照
    evaluateChange({ fileList }) {
      this.evaluateList = fileList;
    },
    // 异常处理枚举
    solveExceptionWay(item) {
      if (item == "NORMAL") {
        return "正常服务";
      }
      if (item == "MARKUP") {
        return "加价服务";
      }
      if (item == "BACK") {
        return "退回商品";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./_order_info_scoped.scss";
</style>
<style lang="scss">
@import "./_order_info.scss";
.arrival {
  .type_name {
    width: 69px;
  }
}
#orderlist {
  &.evaluate {
    .el-dialog__header {
      padding: 20px 12px 10px !important;
    }
    .el-rate {
      height: 32px !important;
    }
    .rate-size {
      .iconguanwang_icon_pingjia {
        font-size: 32px !important;
      }
    }

    .el-dialog__body {
      padding: 5px 12px !important;
      position: relative;
      .icon {
        position: absolute;
        right: 45px;
        top: 15px;
        width: 19px;
        height: 19px;
        color: #c9cdd5;
        cursor: pointer;
      }
    }
    .el-dialog__footer {
      padding: 10px 12px 20px;
      margin-top: 10px;
    }
    .evaluate-tab {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 14px;
      height: 14px;
      line-height: 1;
      color: #2f3133;
      margin-bottom: 16px;
      .tab_name {
        width: 77px;
        margin-right: 10px;
        color: #5e6066;
      }
      .avatar-evaluate {
        width: 34px;
        height: 34px;
        margin-right: 12px;
      }
    }
    .evaluate-img {
      height: 36px;
    }
    .imgs-eva {
      height: 60px;
      align-items: flex-start;
      .item-imgs {
        width: 60px;
        height: 60px;
        margin-right: 7px;
      }
      .item-imgs:last-child {
        margin-right: 0px;
      }
    }
    .imgs-score {
      height: 32px;
      align-items: center;
      color: #5e6066;
      .item-imgs {
        width: 32px;
        height: 32px;
        margin-right: 7px;
      }
      .item-imgs:nth-child(6) {
        margin-right: 15px;
      }
    }
    .eva-impression {
      min-height: 70px;
      .impression {
        display: flex;
        flex-wrap: wrap;
        width: 480px;
        .tabs {
          padding: 9px 11px;
          border: 1px solid #b4b7bc;
          border-radius: 16px;
          font-size: 12px;
          color: #5e6066;
          cursor: pointer;
          margin: 0 8px 6px 0;
        }
        .selected {
          border-color: #3455d3;
          color: #3455d3;
        }
        .tabs:last-child {
          margin: 0 0 6px 0;
        }
      }
    }
    .eva-content {
      height: 187px;
      align-items: flex-start;
      .textarea-text {
        width: 460px;
        height: 187px;
        textarea {
          resize: none;
          height: 100%;
          border-radius: 2px;
        }
        textarea:hover,
        textarea:focus {
          border-color: #3455d3;
        }
      }
    }
    .eva-upload-imgs {
      display: flex;
      .complaint-title {
        margin-right: 26px !important;
      }
      .ant-upload-list-item {
        width: 52px !important;
        height: 52px !important;
        margin: 0 7px 5px 0 !important;
      }
      .ant-upload.ant-upload-select-picture-card {
        width: 52px !important;
        height: 52px !important;
        // margin-left: 0 !important;
      }
    }
    .el-dialog {
      width: 572px !important;
    }
  }
  &.complaint {
    .two_label {
      display: block !important;
    }
    .type_name {
      margin-bottom: 12px;
    }
    .type_content {
      margin-left: 0 !important;
      width: 100% !important;
      textarea {
        width: 100% !important;
        height: 130px !important;
      }
    }
    .complaint-img {
      & > span {
        display: flex;
        flex-wrap: wrap;
      }
      .complaint-title {
        font-size: 14px;
        height: 14px;
        line-height: 1;
        color: #2f3133;
        margin: 24px 0 14px 0;
        white-space: nowrap;
      }
      .ant-upload.ant-upload-select-picture-card {
        width: 50px;
        height: 50px;
        border-radius: 2px;
        margin-left: 4px;
        margin-right: 0;
      }
      .ant-upload.ant-upload-select-picture-card > .ant-upload {
        padding: 0;
      }
      .ant-upload.ant-upload-select-picture-card:hover,
      .ant-upload.ant-upload-select-picture-card:hover {
        border-color: #3455d3;
      }
      .ant-upload-text {
        font-size: 12px;
      }
      .ant-upload-list {
        width: auto !important;
        height: 50px;
      }
      .ant-upload-list-picture-card .ant-upload-list-item {
        height: 50px;
        width: 50px;
        margin: 0 5px 5px 0;
        padding: 0;
      }
      .ant-upload-list-picture-card .ant-upload-list-item:last-child {
        margin-right: 0 !important;
      }
      .ant-upload-list-item-info > span {
        height: 100%;
      }
      // .ant-upload-list-item-actions {
      //   & > a {
      //     display: none;
      //   }
      // }
    }
  }
}
</style>
